import { circularProgressClasses } from '@mui/material/CircularProgress';
import { theme } from '@/utils/theme';

export const classes = {
  wrapper: 'relative place-center',
};

export const styles = {
  background: {
    color: theme.palette['grey-3'].main,
  },
  spinner: {
    color: theme.palette['orange-3'].main,
    animationDuration: '1000ms',
    position: 'absolute',
    left: 0,
    [`& .${circularProgressClasses.circle}`]: {
      strokeLinecap: 'round',
    },
  },
};
